import { css } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import { typography } from "@shared/common/Themes/typography";

export const StatusTagStyles = {
  wrapper: css<{
    $color: string;
    $withBgColor: boolean;
    $size?: "small";
  }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    color: ${(p) => p.$color};
    border-radius: ${(p) => (p.theme.isNewLook ? 6 : 8)}px;
    font-weight: ${typography.fontWeights.MEDIUM};
    font-size: ${typography.fontSizes.M};
    ${(p) =>
      p.$withBgColor &&
      `
      background: ${hexToRGB(p.$color, 0.1)};
      justify-content: space-between;
      padding: 2px 12px;
    `}
    ${(p) =>
      p.$size === "small" &&
      `
      font-size: ${typography.fontSizes.S};
    `}
  `,
};
